import type { ChangelogEntry } from "../types";

/**
 * VIB-2783. Dokumenteditoren bygget om på et ordentlig editor-bibliotek.
 *
 * Ingen rollekrav: alle som kan åpne et dokument i arkivet merker forskjellen,
 * og de som bare leser får samme visning som før.
 */
export const DOKUMENTEDITOR_LEXICAL_2026_10: ChangelogEntry = {
  id: "2026-10-05-dokumenteditor-lexical",
  date: "2026-10-05",
  title: "Dokumenteditoren er bygget om",
  summary:
    "Verktøylinja har fått ikoner i stedet for bokstaver, lenke og video åpner i sin egen lille boks, og du kan angre.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Verktøylinja har ikoner",
          kind: "forbedret",
          body: "Knappene for fet, kursiv, overskrift og liste viste bokstaver og tegn («F», «K», «H2», «•»). Nå er de ikoner, og knappen lyser opp når det du har markert alt har den formateringen. Da ser du hva som er på, i stedet for å måtte prøve.",
        },
        {
          title: "Lenke og video åpner i sin egen boks",
          kind: "forbedret",
          body: "Adressefeltet lå før inni samme boks som knappene, og verktøylinja vokste og flyttet seg når du åpnet det. Nå åpner det seg som en liten boks under knappen du trykket på, og knappene står stille.",
        },
        {
          title: "Du kan angre",
          kind: "nytt",
          body: "Ctrl+Z (Cmd+Z på Mac) angrer det du nettopp gjorde i dokumentet, og Ctrl+Shift+Z gjør det om igjen. Det virket ikke pålitelig før.",
        },
        {
          title: "Bilde kan limes inn, ikke bare dras inn",
          kind: "nytt",
          body: "Har du kopiert et bilde, kan du lime det rett inn i teksten med Ctrl+V. Det lastes opp og krympes på samme måte som når du drar det inn.",
        },
        {
          title: "Innliming fra Word og nettsider tar vare på mer",
          kind: "forbedret",
          body: "Limer du inn fra et annet program, beholdes overskrifter, lister, fet og kursiv der vi har noe å vise det med. Det vi ikke kan vise, for eksempel en tabell eller et sitat, blir vanlig tekst i stedet for å forsvinne.",
        },
      ],
    },
  ],
};
